/*
 * Share one in-flight request between callers that ask for the same thing at the same time.
 *
 * Several hooks load the same season at once — the plan board, the tetris page and the chat's plan
 * panel each run their own instance — and each was issuing its own queries. The entry is dropped as
 * soon as the request settles, so this only collapses overlap and never serves a stale result.
 */
export function dedupeInflightRequest(store, key, load) {
  const existing = store.get(key);
  if (existing) return existing;
  const request = Promise.resolve().then(load);
  store.set(key, request);
  request.finally(() => {
    if (store.get(key) === request) store.delete(key);
  }).catch(() => {});
  return request;
}
